// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__hVcq3","header__text":"Header_header__text__3jVIX","account":"Header_account__LU5mo"};